import React, { memo } from 'react'

import Popup from '../../shared/popup/Popup'
import customConfig from 'customConfig'
import { exchangeProviderLabel } from '../../../util/pointsExchange.helpers'
import brandConfig from 'brandConfig'
import { formatTicks } from '../../../util/string.helpers'
import DisplayValue from '../../shared/text/DisplayValue'

const ReceivePoints = ({
  title,
  description,
  color,
  onSubmit,
  onCancel,
  children,
  t,
  name,
  symbol,
  cancelLabel = customConfig.goBackLabel,
  icon,
  value,
  additionalDesc,
  ...restProps
}) => {
  return (
    <Popup
      title={title}
      description={description}
      icon={icon}
      color={color}
      onFormSubmit={onSubmit}
      cancelLabel={onCancel && t(cancelLabel)}
      onCancel={onCancel && onCancel}
      {...restProps}
    >
      {additionalDesc}
      {value && (
        <DisplayValue
          title={formatTicks(value)}
          desc={
            brandConfig.brandSymbol
              ? exchangeProviderLabel({ name })
              : exchangeProviderLabel({ name, symbol })
          }
        />
      )}
      {children && children}
    </Popup>
  )
}

export default memo(ReceivePoints)
